import { mobile, styled } from '@obvio/app'
import { Modal } from '@obvio/ui'

export const LightModal = styled(Modal)`
  background: #ffffff;
  color: #000000;
  > section {
    padding-left: ${(theme) => theme.spacing.extraLarge};
    padding-right: ${(theme) => theme.spacing.extraLarge};
  }
  @media ${mobile} {
    > section {
      padding: ${(theme) => theme.spacing.small};
      > div {
        height: 100%;
        display: flex;
        flex-direction: column;
      }
    }
  }
`
